<template>
  <div class="field-container">
    <div :class="classes">
      <label v-if="label">
        {{ label }}
      </label>
      <input ref="input" v-bind="$attrs" :class="inputClasses" />
    </div>
  </div>
</template>
<script>
/* globals App */
export default {
  inheritAttrs: false,
  props: {
    error: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    datepicker: {
      type: Boolean,
    },
    datepickerOptions: {
      type: Object,
      default() {
        return { altInput: true, altFormat: "d.m.Y", disableMobile: true };
      },
    },
  },
  computed: {
    inputClasses() {
      return this.datepicker ? " no-init flatpickr-input" : "";
    },
    classes() {
      return {
        "input-container": true,
        "border-red-500": this.error,
        border: true,
        "border-dark-29": !this.error,
      };
    },
  },
  mounted() {
    if (this.datepicker) {
      window.App.getForms().then(() => {
        App.forms.initPicker(this.$refs.input, this.datepickerOptions);
      });
    }
  },
};
</script>
